import React from "react";
import "./App.css";
import RyujinImages from "./RyujinImages.js";
import RyujinQuotes from "./RyujinQuotes.js";
import VisitorCounter from "./VisitorCounter.js";
import NewsletterSignup from "./NewsletterSignup.js";
import Guestbook from "./Guestbook.js";
import Timeline from "./Timeline.js";
import FunFacts from "./FunFacts.js";
import WhyRyujin from "./WhyRyujin.js";
import VideoSection from "./VideoSection.js";
import Navigation from "./Navigation.js";
import SocialMedia from "./SocialMedia.js";

const App = () => {
  return (
    <div className="app">
      <Navigation />
      <div id="gallery">
        <RyujinImages />
      </div>
      {/* <VisitorCounter /> */}
      {/* <div id="quotes">
        <RyujinQuotes />
      </div> */}
      {/* <div id="newsletter">
        <NewsletterSignup />
      </div> */}
      {/* <div id="guestbook">
        <Guestbook />
      </div> */}
      {/* <div id="videos">
        <VideoSection />
      </div>
      <div id="timeline">
        <Timeline />
      </div> */}
      {/* <div id="facts">
        <FunFacts />
      </div> */}
      {/* <div id="why-ryujin">
        <WhyRyujin />
      </div> */}
      {/* <SocialMedia /> */}
    </div>
  );
};

export default App;
